/* eslint-env browser */
/* eslint-disable no-console */
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Flatpickr from 'react-flatpickr';
import {toast} from 'react-toastify';
import moment from 'moment';
import 'react-select/dist/react-select.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-activity/dist/react-activity.css';
import '../../../node_modules/flatpickr/dist/themes/material_blue.css';
import '../../common/webar_flatpickr.css';
import {getInvoiceTotal, getSelectedInvoiceKeys, getSelectedPrimaryAccount} from './Selectors';

import {updateInvoiceSearchDueToDate, clearSelectedInvoices, updateSelectedCard} from '../../actions/InvoiceActions';
import * as appConstants from '../../constants/ApplicationConstants';
import * as validationTypes from '../../constants/ValidationConstants';
import SoldToSelect from './SoldToSelect';
import SoldToSelectAll from './SoldToSelectAll';
import PayerSelect from './PayerSelect';
import InvoiceList from './InvoiceList';
import {formatMoney} from '../../common/invoiceHelpers';
import {canMakePayment} from "../../PermissionSelectors";
import BasePageErrorBoundary from "../../error-boundaries/BasePageErrorBoundary";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleRight, faCalendar, faCalendarAlt, faCaretUp, faChevronDown} from "@fortawesome/free-solid-svg-icons";


class Invoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPaymentStatusOption: '',
      hasOneDropDownItems: false,
      selectedDueOption: 'all'
    };

    // this.handleCustomerChange = this.handleCustomerChange.bind(this);
    this.handleSelectedDates = this.handleSelectedDates.bind(this);
    this.onContinueClick = this.onContinueClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
  }

  componentDidMount() {
    updateSelectedCard(this.props.dispatch, "");
  }

  onContinueClick = event => {
    if (this.props.selectedInvoicesKeys.length === 0) {
      event.preventDefault();
      toast.warn(validationTypes.INVOICE_CHECK, {position: toast.POSITION.TOP_RIGHT});
      return;
    }
    if (this.props.invoiceTotal <= 0) {
      event.preventDefault();
      toast.warn(
        validationTypes.CREDIT_AMOUNT_VALIDATION_ERRORS,
        {position: toast.POSITION.TOP_RIGHT},
      );
      return;
    }
  };

  onSearchClick = () => {
    clearSelectedInvoices(this.props.dispatch);
  };

  handleSelectedDates(selectedDates) {
    clearSelectedInvoices(this.props.dispatch);
    let toDate = '';
    if (selectedDates && selectedDates.length > 0) {
      toDate = moment(selectedDates[0]).format('MM-DD-YYYY');
    } else {
      toDate = moment(new Date().getFullYear(), 11, 31).format('MM-DD-YYYY');
    }
    updateInvoiceSearchDueToDate(this.props.dispatch, toDate);
  }

  handleDueChange = event => {
    clearSelectedInvoices(this.props.dispatch);
    let selectedDueOption = event.target.value;
    this.setState({selectedDueOption});
    let defaultToDate = moment(new Date()).format('MM-DD-YYYY');
    if (selectedDueOption === 'due-up-to' || selectedDueOption === '') {
      defaultToDate = moment(new Date()).format('MM-DD-YYYY');
    } else if (selectedDueOption === 'all') {
      defaultToDate = '';
    }
    updateInvoiceSearchDueToDate(this.props.dispatch, defaultToDate);
  };

    renderSecondarySelect() {

    switch (this.props.accountType) {
      case appConstants.SOLD_TO_COMPARE:
        return <PayerSelect/>;
      case appConstants.PAYER_COMPARE:
        return <SoldToSelect/>;
      case appConstants.ACCOUNT_PAYER_ALL:
        return <SoldToSelectAll/>;
      default:
        return null;
    }
  }

  render() {
    const toDate = this.props.invoiceSearchDueDateTo ? new Date(this.props.invoiceSearchDueDateTo) : '';
    const hasOneDropDownItems = this.state.hasOneDropDownItems;
    if (this.props.secondaryAccounts && this.props.secondaryAccounts.length === 1 && !hasOneDropDownItems) {
      this.setState({hasOneDropDownItems: true});
    }


    return (
      <div className="container" id="invoicePage">
          <div id="divFilterControls" className="row">
            <div className="col-lg-3 col-sm-4 form-group">
              {this.renderSecondarySelect()}
            </div>
            <div className="col-lg-2 col-sm-4 form-group customSelect">
              <select className={'form-control invoicesHeadingInput'} onChange={this.handleDueChange}
                      value={this.state.selectedDueOption}>
                <option value="all">Show All</option>
                <option value="due-up-to">Due til</option>
              </select>
              <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"}/>
            </div>

            {this.state.selectedDueOption !== 'all' && (
              <div className="col-lg-2 col-sm-4 form-group">
                <div>
                  <FontAwesomeIcon icon={faCalendarAlt} className={"calendarPosition"}/>
                  <Flatpickr
                    className="inp form-control inv-calendar"
                    value={toDate}
                    options={{dateFormat: 'M-d'}}
                    onClose={this.handleSelectedDates}
                    placeholder="Due Til"
                  />
                </div>
              </div>
            )}
            {/* SCHINDLER DOES NOT WANT INVOICE SEARCH HERE.*/}
            {/*<div className="col-lg-1 col-md-1 col-2 form-group search p-0">*/}
              {/*<Link to="/invoices/invoicesearch" onClick={this.onSearchClick}>*/}
                {/*<span className="fas fa-search fa-lg"/>*/}
              {/*</Link>*/}
            {/*</div>*/}
            <div className="col-lg-2 col-md-6 col-8 form-group d-flex align-items-center p-0">
              <span className="invoicesHeading">Pay </span>
              <span className={this.props.invoiceTotal >= 0 ? 'credit-positive' : 'credit-negative'}>
              &nbsp;&nbsp;${formatMoney(this.props.invoiceTotal)}
            </span>
            </div>
            {this.state.selectedDueOption === 'all' && (
              <div className="col-lg-2 col-sm-4 form-group">
              </div>
            )}
            <div className="col-lg-2 col-md-5 col-sm-12 text-right form-group">
              {this.props.canMakePayment &&
              <Link className="btn btn-primary buttonColor" to="/invoices/pay" onClick={this.onContinueClick}>
                Continue <FontAwesomeIcon icon={faAngleRight}/>
              </Link>}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <InvoiceList/>
            </div>
          </div>
      </div>
    );
  }
}

Invoices.propTypes = {
  dispatch: PropTypes.func.isRequired,
  reasonNotRequired: PropTypes.string.isRequired
};

// TODO cleanup unused props.
export default connect((store, props) => ({
  accountType: store.user_options.accountType,
  cnbsConfig: store.default.cnbsConfig,
  currencyOptions: store.default.currencyOptions,
  currentUser: store.default.currentUser,
  dueOptions: store.default.dueOptions,
  invoiceListRequest: store.default.invoiceListRequest,
  invoiceSearchDueDateTo: store.user_options.invoiceSearchDueDateTo,
  invoiceSearchFromDate: store.default.invoiceSearchFromDate,
  invoiceSearchToDate: store.user_options.invoiceSearchToDate,
  invoiceTotal: getInvoiceTotal(store, props),
  listHeight: store.default.listHeight,
  payerDetails: store.default.payerDetails,
  paymentCardOptions: store.default.paymentCardOptions,
  paymentStatusOptions: store.default.paymentStatusOptions,
  paymentStatuses: store.default.paymentStatuses,
  reasonNotRequired: store.default.reasonNotRequired,
  secondaryAccounts: store.user_options.secondaryAccounts,
  selectedCurrencyOptionValue: store.default.selectedCurrencyOptionValue,
  selectedInvoices: store.invoice.selected,
  selectedInvoicesKeys: getSelectedInvoiceKeys(store, props),
  selectedPrimaryAccount: getSelectedPrimaryAccount(store, props),
  selectedSecondaryAccount: store.user_options.selectedSecondaryAccount,
  totalAmountWithCredit: store.default.totalAmountWithCredit,
  userCustomerDetails: store.user_options.primaryAccounts,
  canMakePayment: canMakePayment(store),
}))(Invoices);
